<div mat-dialog-content>
  <span class="text-lg font-semibold">{{ data.message }}</span>
</div>
<div mat-dialog-actions *ngIf="data.confirmation">
  <button type="button" mat-button color="primary" (click)="confirm()">Yes</button>
  <button type="button" mat-button color="warn" (click)="cancel()">No</button>
</div>

<div mat-dialog-actions *ngIf="!data.confirmation">
  <button type="button" mat-raised-button color="warn" (click)="cancel()">OK</button>
</div>
